/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastChanges/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LastChanges({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/LastChanges"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let providerAccountUpdatedByUserVaxiomPersonValueData = fromData.useDataFormat({ viewPath,
context: 'provider_account',
path: 'updated_by_user.vaxiom_person',
format: fromFormat.personName,
})
let providerAccountUpdatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'provider_account',
path: 'updated_at',
format: fromFormat.dateISOToDateAndTime,
})
  return (<React.Fragment
>
<div
  data-testid="LastChanges.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Last updated by"
 color={dtColorsNeutral500}
 marginRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="provider_account.updated_by_user.vaxiom_person"
 format="/Data/format.js personName"
 text={providerAccountUpdatedByUserVaxiomPersonValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="on"
 color={dtColorsNeutral500}
 marginRight={dtSpaceXxs}
 marginLeft={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="provider_account.updated_at"
 format="/Data/format.js dateISOToDateAndTime"
 text={providerAccountUpdatedAtValueData}
/>
</div>
{children}
</React.Fragment>)
}